<template>
	<div class="card border-0 bg-transparent">
		<slot>
		</slot>
	</div>
</template>

<script>

export default {
}

</script>
